import { connect } from 'react-redux';

import React, { Component } from 'react';
import {
  clearSelectedPatient,
  editClinic,
  getClinicData,
  getCurvesList,
  getPatientDetails,
  getPatientsByClinicId,
  getSettings,
  getUsers,
  getUsersByClinicId,
  navigateTo,
  setDiagnosis,
  setError,
  setNewPass,
  setSettings,
  setSuccess,
} from '../../redux/actions';
import { colors, patientDetailsStyles } from '../../theme/style';
import { getClinicStatus, isAdminClinic, isLoggedInis, isUserClinic } from '../../utils/CFuncs';
import { roles, urls } from '../../utils/Objects';
import { Items, Storage } from '../../utils/StorageHelper';
import { Loading } from '../common';
import Alerts from '../common/Alerts';
import QrCode from '../common/QrCode';
import BackToPage from '../common/back-to-page';
import AdminLayout from '../user/admin/AdminLayout';
import ClinicModal from './ClinicModal';

class clinicDetails extends Component {
  qrRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      image: null,
      open: false,
      img: 0,
      info: false,
      pass: false,
      newPass: '',
      showModal: false,
    };
  }
  componentDidMount() {
    console.log('componentDidMount clicniDetails');
    let clinicId = null;
    if (isLoggedInis(roles.Administrator)) {
      clinicId = this.props.clinicId;
    } else if (isLoggedInis(roles.HealthCareProvider)) {
      clinicId = Storage.get(Items.clinicId);
    }

    try {
      this.props.getClinicData(clinicId);
      if (clinicId) {
        !isUserClinic() && this.props.getUsersByClinicId(clinicId);
        this.props.getPatientsByClinicId(clinicId);
      } else {
        !isUserClinic() && this.props.getUsers();
        this.props.getPatients();
      }
    } catch (error) {
      console.log('No Clinic');
    }
  }

  componentWillUnmount() {
    // this.props.clearSelectedPatient()
  }
  openModal = () => {
    this.props.setError('');
    this.props.setSuccess('');
    this.setState({ ...this.state, showModal: true });
  };
  closeModal = () => {
    this.setState({ ...this.state, showModal: false });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  ImgCarousel = (props) => {
    const itemList = props.list;
    return (
      <div className="row" style={{ alignItems: 'center' }}>
        <div
          style={{ ...styles.buttonScroll, fontSize: 36 }}
          onClick={() => {
            this.state.img > 0 && this.setState({ img: this.state.img - 1 });
          }}
        >
          {'<'}
        </div>

        <div style={{ margin: 5 }}>
          <img src={itemList[this.state.img]} width={250} height={400} />
          <div>Radiograph date:11/1/2021</div>
        </div>

        <div
          style={{ ...styles.buttonScroll, fontSize: 36 }}
          onClick={() => {
            this.state.img < itemList.length - 1 && this.setState({ img: this.state.img + 1 });
          }}
        >
          {'>'}
        </div>
      </div>
    );
  };

  render() {
    console.log('rendering...' + 'ClinicDetails');

    const { selectedClinic } = this.props;

    console.log(selectedClinic);
    try {
      return (
        <div style={styles.bigContainer}>
          <AdminLayout {...this.props}>
            <Alerts />
            <div navstyle={patientDetailsStyles.navstyle}>
              <BackToPage link={urls.clinics} text="clinics" />
            </div>

            {selectedClinic && (
              <ClinicModal
                closeModal={this.closeModal}
                showModal={this.state.showModal}
                handleClick={this.props.editClinic}
                title="Edit Clinic"
                currentClinic={selectedClinic}
              />
            )}

            <div style={styles.medContainer}>
              <div style={styles.container}>
                {/* <div style={styles.title}><label>id: </label><span>{selectedClinic.id}</span></div> */}
                <div style={styles.title}>
                  <label>name:</label>
                  <span>{' ' + selectedClinic.name}</span>
                </div>
                <div>
                  <label>status: </label>
                  <span>{' ' + getClinicStatus(selectedClinic?.status)}</span>
                </div>

                <div>
                  <label>location:</label>
                  <span>{' ' + selectedClinic.location}</span>
                </div>

                <div>
                  <label>email:</label>
                  <span>{' ' + selectedClinic.email}</span>
                </div>

                <div>
                  <label>phone:</label>
                  <span>{' ' + selectedClinic.phone}</span>
                </div>

                {(isAdminClinic() || isLoggedInis(roles.Administrator)) && (
                  <div>
                    <label>users amount:</label>
                    <span>{this.props.usersClinic?.length}</span>
                  </div>
                )}
                <div>
                  <label>patients amount:</label>
                  <span>{this.props.patientsList?.length}</span>
                </div>

                {(isAdminClinic() || isLoggedInis(roles.Administrator)) && (
                  <button style={styles.button} onClick={() => this.openModal()}>
                    edit clinic
                  </button>
                )}
              </div>
              <QrCode name={selectedClinic.name} id={selectedClinic.id?.toString()} />
            </div>
          </AdminLayout>
        </div>
      );
    } catch (error) {
      console.log(error);
      return <Loading />;
    }
  }
}

const styles = {
  error: {
    fontWeight: 'bold',
    color: '#f7183a',
  },
  bigContainer: {
    // border: '1px solid',
    flex: 1,
    position: 'relative',
  },
  medContainer: {
    padding: '1rem',
    position: 'relative',
    // border: '1px solid',
    width: '70vw',
    display: 'flex',
    justifyContent: 'space-between',
  },

  title: {
    fontWeight: 'bold',
    fontSize: '20px',
    fontWeight: 'bold',
  },
  button: {
    cursor: 'pointer',
    backgroundColor: '#4CAF50',
    border: 'none',
    color: 'white',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  buttonDisabled: {
    cursor: 'pointer',
    backgroundColor: '#9f9f9f',
    border: 'none',
    color: 'white',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  buttonScroll: {
    cursor: 'pointer',
    border: 'none',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    fontWeight: 'bold',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  buttonScrollNoMore: {
    cursor: 'pointer',
    border: 'none',
    color: colors.purpleGrey,
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
};

const mapStateToProps = (state, ownProps) => {
  const clinicId = ownProps.location?.state?.clinicId;
  return {
    login: state.login,
    user: state.user,
    message: state.message,
    patientsList: state.clinic.patientsList,
    usersClinic: state.clinic.usersClinic,
    diagnoseLoading: state.user.diagnoseLoading,
    selectedClinic: state.clinic.selectedClinic,
    clinicId,
  };
};

const mapDispatchToProps = {
  getPatientsByClinicId,
  getClinicData,
  getUsersByClinicId,
  getUsers,
  navigateTo,
  getCurvesList,
  getSettings,
  getPatientDetails,
  setSettings,
  setDiagnosis,
  setNewPass,
  clearSelectedPatient,
  editClinic,
  setSuccess,
  setError,
};

export default connect(mapStateToProps, mapDispatchToProps)(clinicDetails);
